import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { endpoints } from 'modules/endpoints'
import { RequestError } from 'modules/errors'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ADefaultModalFooter from 'views/components/DefaultModalFooter/ADefaultModalFooter'
import { SharedModalTitle } from 'views/components/SharedModal'
import ASharedModal from 'views/components/SharedModal/ASharedModal'
import { RailwayRoute, RailwayRouteDTO } from '../../types'
import { RailsModalContent } from './RailsModalContent'

interface Props {
  refetch: () => void
  onClose: () => void
  routeData: RailwayRoute
}

export const EditRailsRatesModal: FC<Props> = ({ onClose, refetch, routeData }) => {
  const { formProgress, formHandler } = useAFormHandler('editRates')
  const { t } = useTranslation('rates')

  const formik = useFormik<RailwayRouteDTO>({
    initialValues: {
      from_station: routeData.from_station.id,
      to_station: routeData.to_station.id,
      rate: routeData.rate,
      comment: routeData.comment,
      product_type: routeData.product_type,
      product: routeData.product ? routeData.product?.id.toString() : null,
      rail_car_owner: routeData.rail_car_owner ? routeData.rail_car_owner.id.toString() : null,
      rail_car_type: routeData.rail_car_type ? routeData.rail_car_type : '',
      start_date: routeData.start_date ? routeData.start_date : null,
      end_date: routeData.end_date ? routeData.end_date : null,
      rail_car_load_limit: routeData.rail_car_load_limit ? routeData.rail_car_load_limit : null,
    },

    onSubmit: formHandler(
      async () => {
        await apiClient.patch(endpoints.LogisticsKR.railwaysRates(routeData.id), formik.values)
      },
      {
        onSuccess: async () => {
          await refetch()
          onClose()
        },

        onError: (err) => {
          const error = err as RequestError
          const { errors } = error
          formik.setErrors(errors)
        },
      },
    ),
  })

  return (
    <ASharedModal id="editRailwayTarif" size="medium" onClose={onClose}>
      <SharedModalTitle>{t('modal.heading')}</SharedModalTitle>

      <RailsModalContent formik={formik} isEdit />

      <ADefaultModalFooter
        confirmButtonText={t('common:save')}
        onClose={onClose}
        onConfirm={() => formik.submitForm()}
        progress={formProgress}
      />
    </ASharedModal>
  )
}
